import React from "react";
//#region types
import { NavigationItem, RouteBreadCrumbProps } from "models/propTypes/navigationPropTypes";
import { RouteInfo } from "models/utilTypes/routeTypes";
import { RouteConfigConstants } from "utils/constants";
//#endregion
//#region components
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import BreadCrumb from "./breadCrumb";
//#endregion
import { AppState } from "store";
import { LocalizationHelperInstance } from "utils/helpers";

const RouteBreadCrumb: React.FC<RouteBreadCrumbProps> = (props) => {
  const company = useSelector((state: AppState) => state.auth.selectedCompany);
  const location = useLocation();

  const [prevItems, setPrevItems] = React.useState<NavigationItem[]>([]);
  const [currentItem, setCurrentItem] = React.useState<string>("/");
  const [pathCount, setPathCount] = React.useState<number>();

  const getHref = (matchingRoute: RouteInfo) => {
    return !matchingRoute.disableBackNavigation
      ? matchingRoute.element || matchingRoute.children
        ? `/${company.url}/${matchingRoute.backNavigationPath ?? matchingRoute.path}`
        : undefined
      : undefined;
  };

  const getBreadCrumbItem = (paths: string[], routeConfigs: RouteInfo[]) => {
    const navItemsToDisplay: NavigationItem[] = [];
    if (paths.length > 0) {
      if (paths.length === 1 && props.current !== undefined) {
        setCurrentItem(LocalizationHelperInstance.getFormattedMessage(props.current, props.current));
      } else {
        const pathToMatch = paths[0];
        const matchingRoute = routeConfigs.find((x) => x.path.toLowerCase() === pathToMatch.toLowerCase());

        if (matchingRoute !== undefined) {
          if (paths.length === 1) {
            const emptyChild = (matchingRoute?.children as Array<RouteInfo>)?.find((x) => x.path === "");

            if (emptyChild) {
              const navItemToDisplay = {
                text: LocalizationHelperInstance.getFormattedMessage(
                  matchingRoute.displayText ?? "",
                  matchingRoute.displayText
                ),
                href: getHref(matchingRoute),
              };

              navItemsToDisplay.push(navItemToDisplay);

              setCurrentItem(
                LocalizationHelperInstance.getFormattedMessage(emptyChild.displayText ?? "", emptyChild.displayText)
              );
            } else
              setCurrentItem(
                LocalizationHelperInstance.getFormattedMessage(
                  matchingRoute.displayText ?? "",
                  matchingRoute.displayText
                )
              );
          } else {
            const navItemToDisplay = {
              text: LocalizationHelperInstance.getFormattedMessage(
                matchingRoute.displayText ?? "",
                matchingRoute.displayText
              ),
              href: getHref(matchingRoute),
            };

            navItemsToDisplay.push(navItemToDisplay);

            const navItems = getBreadCrumbItem(paths.slice(1), matchingRoute.children as Array<RouteInfo>);
            if (navItems !== undefined && navItems.length > 0) {
              navItemsToDisplay.push(...navItems);
            }
          }
        }
      }
    }

    return navItemsToDisplay;
  };

  React.useEffect(() => {
    let path = location.pathname;
    if (company != null) path = path.replace("/".concat(company.url ?? ""), "");
    const paths = path.split("/").filter((parts) => parts !== "");
    setPathCount(path.length);

    const navItemsToDisplay = getBreadCrumbItem(paths, RouteConfigConstants.RouteDescriptions);
    setPrevItems(navItemsToDisplay);
  }, [company, LocalizationHelperInstance.intl, props.current]);

  return (
    <BreadCrumb
      prevItems={prevItems}
      current={currentItem}
      showEndSeparator={(props.showEndSeparator === undefined && pathCount === 1) || props.showEndSeparator}
      showHome={props.showHome}
      className={props.className}
    />
  );
};

export default RouteBreadCrumb;
